import classNames from "classnames";
import * as React from "react";

export const Card: React.FC<React.ComponentProps<"div">> = ({
  className,
  ...props
}) => {
  return (
    <div
      data-slot="card"
      className={classNames(
        "bg-card text-card-foreground flex flex-col gap-6 rounded-xl border",
        className,
      )}
      {...props}
    />
  );
};

export const CardHeader: React.FC<React.ComponentProps<"div">> = ({
  className,
  ...props
}) => {
  return (
    <div
      data-slot="card-header"
      className={classNames(
        "@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6",
        className,
      )}
      {...props}
    />
  );
};

export const CardTitle: React.FC<React.ComponentProps<"div">> = ({
  className,
  ...props
}) => {
  return (
    <h4
      data-slot="card-title"
      className={classNames("leading-none", className)}
      {...props}
    />
  );
};

export const CardDescription: React.FC<React.ComponentProps<"div">> = ({
  className,
  ...props
}) => {
  return (
    <p
      data-slot="card-description"
      className={classNames("text-muted-foreground", className)}
      {...props}
    />
  );
};

export const CardAction: React.FC<React.ComponentProps<"div">> = ({
  className,
  ...props
}) => {
  return (
    <div
      data-slot="card-action"
      className={classNames(
        "col-start-2 row-span-2 row-start-1 self-start justify-self-end",
        className,
      )}
      {...props}
    />
  );
};

export const CardContent: React.FC<React.ComponentProps<"div">> = ({
  className,
  ...props
}) => {
  return (
    <div
      data-slot="card-content"
      className={classNames("px-6 [&:last-child]:pb-6", className)}
      {...props}
    />
  );
};

export const CardFooter: React.FC<React.ComponentProps<"div">> = ({
  className,
  ...props
}) => {
  return (
    <div
      data-slot="card-footer"
      className={classNames(
        "flex items-center px-6 pb-6 [.border-t]:pt-6",
        className,
      )}
      {...props}
    />
  );
};
